const toReal = {
    'sponsorMediaValue-desc': 'sponsorMediaValue-desc',
};

const toFake = {
    'sponsorMediaValue-desc': 'sponsorMediaValue-desc',
};

export default { toReal, toFake };
